export const gambio = {
  passwordLabel: "Password",
  urlHelp:
    "The base URL of your shop without an API path, e.g. https://shop.example.com. The API path is appended automatically.",
  usernameHelp:
    "Email address of a Gambio admin account that is allowed to use the API.",
  passwordHelp: "Password of that Gambio admin account."
};
